import { useEffect, useState } from "react";
import { ethers } from "ethers";
import axios from 'axios';
import contract from "../utils/mint_contract.json";
import metadata from "../utils/metadata.json";
import { createContract, getNetworkId } from "../utils/ethersHelpers";
import { useAppKitAccount, useAppKitProvider, useAppKit } from '@reown/appkit/react';
import './Sale.css';
import './Revving.css';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Link
} from "react-router-dom";

import RevvingH2Webp from '../img/Revving-h2.webp';
import RevvingH2 from '../img/Revving-h2.png';
import RevvingColorWebp from '../img/revving-color.webp';
import RevvingColor from '../img/revving-color.png';
import RevvingMonoWebp from '../img/revving-mono.webp';
import RevvingMono from '../img/revving-mono.png';
import errorIcon from '../img/xmark-solid.svg';
import timeIcon from '../img/time-icon.svg';

import Header from './Header';
import Footer from './Footer';
import Caution from './Caution';
import Spacer from './Spacer';
// import { Gallery } from './RevvingScore';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

/* eslint-disable import/first */
// WalletConnect v1はethers v6と互換性がないため、一時的に無効化
// TODO: WalletConnect v2への移行が必要
// import WalletConnectProvider from "@walletconnect/web3-provider";

//  Create WalletConnect Provider
// const provider = new WalletConnectProvider({
//     infuraId: import.meta.env.VITE_INFURA_API_KEY,
// });

const initialInfoState = {
    connected: false,
    status: null,
    account: null,
    provider: null,
    contract: null,
    address: null,
    contractJSON: null,
    wallet_connect: null,
    network: null,
};

const initialMintState = {
    loading: false,
    status: "",
    amount: 1,
    supply: "0",
    sold: "0",
    endPoint: 0,
    revving_period: [],
    owner_of: [],
    isStatus: false,
    nft_own_status: "",
};

const DownloadButton = ({ downloadUrl, index, metadata, mintInfo }) => {
    const [showPopup, setShowPopup] = useState(false);

    const handleDownloadClick = () => {
        setShowPopup(true);
    };

    const handleOkClick = () => {
        window.open(metadata[mintInfo.owner_of[index]].download_url, '_blank');
        setShowPopup(false);
    };

    const handleCancelClick = () => {
        setShowPopup(false);
    };

    return (
        <>
            <button
                className="Revving__item__revvingBtn"
                onClick={handleDownloadClick}
            >
                Download
            </button>

            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup">
                        <p>
                            I have reviewed and agreed to <Link to="/rule3dmodel" target="_blank">the Terms of Use</Link> in order to download the BŌSŌ TOKYO 3D model.
                        </p>
                        <div className="popup-buttons">
                            <button onClick={handleCancelClick}>Cancel</button>
                            <button onClick={handleOkClick}>OK</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};


function Revving() {
    // AppKitのフックを使用
    const { address, isConnected } = useAppKitAccount();
    const { walletProvider } = useAppKitProvider("eip155");
    const { open } = useAppKit();  // AppKitのウォレット接続モーダルを開く

    const [info, setInfo] = useState(initialInfoState);
    const [mintInfo, setMintInfo] = useState(initialMintState);

    // AppKitのプロバイダーからコントラクトインスタンスを初期化
    useEffect(() => {
        const initContract = async () => {
            if (isConnected && walletProvider && address) {
                try {
                    // AppKitのプロバイダーからEthers.jsのBrowserProviderを作成
                    const ethersProvider = new ethers.BrowserProvider(walletProvider);
                    const networkId = await getNetworkId(ethersProvider);

                    if (networkId == contract.chain_id) {
                        const contractInstance = await createContract(
                            contract.address,
                            contract.abi,
                            ethersProvider
                        );

                        setInfo((prevState) => ({
                            ...prevState,
                            connected: true,
                            status: null,
                            account: address,
                            provider: ethersProvider,
                            contract: contractInstance,
                            contractJSON: contract,
                            wallet_connect: false,
                            network: true,
                        }));
                    } else {
                        setInfo((prevState) => ({
                            ...prevState,
                            status: `Change network to ${contract.chain}.`,
                            network: false,
                        }));
                    }
                } catch (err) {
                    setInfo((prevState) => ({
                        ...prevState,
                        connected: false,
                    }));
                }
            } else {
                // 接続されていない場合は初期状態にリセット
                setInfo(initialInfoState);
            }
        };

        initContract();
    }, [isConnected, walletProvider, address]);

    // ウォレット接続ボタンのハンドラー
    const handleConnect = () => {
        if (!isConnected) {
            open();
        }
    };

    // 総数を取得
    const getTotalSold = async () => {
        try {
            setMintInfo((prevState) => ({
                ...prevState,
                nft_own_status: "Connecting...",
            }));

            let result = await info.contract.totalSold();
            // ethers v6はBigIntを返す可能性があるため、文字列に変換
            setMintInfo((prevState) => ({
                ...prevState,
                sold: result.toString(),
            }));
            // console.log('totalSold取得成功')
            // console.log(result)
        } catch (err) {
            // console.log('totalSold取得失敗')
            setMintInfo((prevState) => ({
                ...prevState,
                sold: "0",
            }));
        }
    };

    // Etherscan APIからトランザクション履歴を取得して所有NFTを特定
    const getOwnedNFTsFromEtherscan = async () => {
        try {
            if (!info.contract || !info.account) {
                return [];
            }

            const response = await axios.get('https://api.etherscan.io/v2/api', {
                params: {
                    chainid: 1, // Ethereum Mainnet
                    module: "account",
                    action: "tokennfttx",
                    contractaddress: "0xF10A5F9FEEF5b3C52C7ca71dC11e467B727C7222",
                    address: info.account,
                    page: 1,
                    offset: 1000, // より多くのトランザクションを取得
                    startblock: 0,
                    endblock: 99999999, // 最新まで取得
                    sort: 'desc',
                    apikey: import.meta.env.VITE_APP_ETHERSCAN_API_KEY,
                }
            });
            // console.log('[DEBUG] API Key:', import.meta.env.VITE_APP_ETHERSCAN_API_KEY);
            // console.log('[getOwnedNFTsFromEtherscan] API Response:', response.data);

            if (!response.data || !Array.isArray(response.data.result)) {
                return [];
            }

            // トランザクションからTokenIDを抽出（重複を排除）
            const tokenIdsFromTx = [...new Set(
                response.data.result
                    .map(item => item.tokenID ? Number(item.tokenID) : null)
                    .filter(id => id !== null)
            )];

            if (tokenIdsFromTx.length === 0) {
                return [];
            }

            // 各TokenIDの現在の所有者を確認（転送されている可能性があるため）
            // バッチ処理でレート制限を回避
            const BATCH_SIZE = 5;

            // 配列をバッチに分割
            const chunk = (array, size) => {
                const chunks = [];
                for (let i = 0; i < array.length; i += size) {
                    chunks.push(array.slice(i, i + size));
                }
                return chunks;
            };

            // 所有者確認関数
            const checkOwnership = async (tokenId) => {
                try {
                    const owner = await info.contract.ownerOf(tokenId);
                    const ownerAddress = typeof owner === 'string'
                        ? owner
                        : owner.toString();
                    return ownerAddress.toLowerCase() === info.account.toLowerCase()
                        ? tokenId
                        : null;
                } catch (err) {
                    // TokenIDが存在しない場合はnullを返す
                    return null;
                }
            };

            // バッチごとに処理
            const batches = chunk(tokenIdsFromTx, BATCH_SIZE);
            const results = [];

            for (const batch of batches) {
                // 各バッチ内は並列実行
                const batchResults = await Promise.all(batch.map(checkOwnership));
                results.push(...batchResults);

                // 次のバッチ前に100ms待機（レート制限対策）
                if (batches.indexOf(batch) < batches.length - 1) {
                    await new Promise(resolve => setTimeout(resolve, 100));
                }
            }

            const ownedFromTx = results
                .filter(id => id !== null)
                .sort((a, b) => a - b);

            return ownedFromTx;
        } catch (err) {
            // Etherscan APIが失敗しても続行（コントラクトから取得できるため）
            return [];
        }
    }


    const getAllOwnedNFTs = async () => {
        try {
            // 必要な値の存在確認
            if (!info.contract) {
                setMintInfo((prevState) => ({
                    ...prevState,
                    owner_of: [],
                    nft_own_status: "No BŌSŌ NFTs detected.",
                }));
                return;
            }

            if (!info.account) {
                setMintInfo((prevState) => ({
                    ...prevState,
                    owner_of: [],
                    nft_own_status: "No BŌSŌ NFTs detected.",
                }));
                return;
            }

            setMintInfo((prevState) => ({
                ...prevState,
                nft_own_status: "Loading NFTs...",
            }));

            // Etherscan APIから所有NFTを取得（効率的な方法）
            // 全NFTをチェックする非効率な方法はコメントアウト済み
            const ownedTokens = await getOwnedNFTsFromEtherscan();

            if (ownedTokens.length === 0) {
                setMintInfo((prevState) => ({
                    ...prevState,
                    owner_of: [],
                    nft_own_status: "No BŌSŌ NFTs detected.",
                }));
            } else {
                setMintInfo((prevState) => ({
                    ...prevState,
                    owner_of: ownedTokens,
                    nft_own_status: "",
                }));
            }
        } catch (err) {
            setMintInfo((prevState) => ({
                ...prevState,
                owner_of: [],
                nft_own_status: "Error loading NFTs. Please try again.",
            }));
        }
    }

    // 自分の所有するNFTの情報を取得
    const getRevvingPeriod = async () => {
        try {
            setMintInfo((prevState) => ({
                ...prevState,
                nft_own_status: "Connecting...",
            }));

            // const result = await info.contract.revvingPeriod(17);
            if (!mintInfo.owner_of || !Array.isArray(mintInfo.owner_of) || mintInfo.owner_of.length === 0) {
                setMintInfo((prevState) => ({
                    ...prevState,
                    nft_own_status: "No BŌSŌ NFTs detected.",
                }));
                return;
            }
            const newArr = mintInfo.owner_of.map(async (item) => {
                const result = await info.contract.revvingPeriod(item);
                // ethers v6は配列を返す: [revving (bool), current (bigint), total (bigint)]
                return {
                    revving: result[0],
                    current: result[1].toString(),
                    total: result[2].toString()
                };
            });
            await Promise.all(newArr).then((values) => {
                if (values.length == 0) {
                    setMintInfo((prevState) => ({
                        ...prevState,
                        nft_own_status: "No BŌSŌ NFTs detected.",
                    }));
                } else {
                    setMintInfo((prevState) => ({
                        ...prevState,
                        nft_own_status: "",
                    }));
                }

                setMintInfo((prevState) => ({
                    ...prevState,
                    revving_period: values,
                }));
            });

        } catch (err) {
            // console.log('revving_period取得失敗')
            setMintInfo((prevState) => ({
                ...prevState,
                revving_period: [],
            }));
        }
    };

    // Revvingボタン
    const toggleRevvingFunc = async (nftNumber) => {
        try {
            // console.log(mintInfo.owner_of);
            setMintInfo((prevState) => ({
                ...prevState,
                status: 'processing...',
                isStatus: true,
            }));
            // ethers v6ではsend()は不要で、直接メソッドを呼び出すとトランザクションが送信される
            const tx = await info.contract.toggleRevving([nftNumber]);
            // トランザクションの確認を待つ
            await tx.wait();
            // console.log('toggle_revving成功')
            setMintInfo((prevState) => ({
                ...prevState,
                status: 'Done!',
                isStatus: true,
            }));

            getRevvingPeriod();
            // console.log(mintInfo.revving_period.revving);
        } catch (err) {
            // console.log('toggle_revving失敗');
            setMintInfo((prevState) => ({
                ...prevState,
                status: 'Failed',
                isStatus: true,
            }));
        }
    };

    // アカウント変更とチェーン変更のリスナー（AppKitが自動的に処理するため不要だが、念のため）
    useEffect(() => {
        if (window.ethereum) {
            const handleAccountsChanged = () => {
                window.location.reload();
            };
            const handleChainChanged = () => {
                window.location.reload();
            };

            window.ethereum.on("accountsChanged", handleAccountsChanged);
            window.ethereum.on("chainChanged", handleChainChanged);

            return () => {
                window.ethereum.removeListener("accountsChanged", handleAccountsChanged);
                window.ethereum.removeListener("chainChanged", handleChainChanged);
            };
        }
    }, []);

    useEffect(() => {
        if (info.connected) {
            getTotalSold();
        }
    }, [info.connected]);

    // コントラクトから直接所有NFTを取得
    useEffect(() => {
        if (info.connected && info.contract && info.account) {
            getAllOwnedNFTs();
        }
    }, [info.connected, info.contract, info.account]);

    useEffect(() => {
        if (mintInfo.owner_of && Array.isArray(mintInfo.owner_of) && mintInfo.owner_of.length > 0) {
            getRevvingPeriod();
            // console.log("useEffect getRevvingPeriod");
        }
    }, [mintInfo.owner_of]);

    // Revvingボタンを押したときのバナーの挙動
    useEffect(() => {
        // console.log("mintInfo.statusが更新");
        const timer = setTimeout(() => {
            // processing..ではない時は3秒後に非表示にする
            if (mintInfo.status !== "processing...") {
                setMintInfo((prevState) => ({
                    ...prevState,
                    isStatus: false,
                }));
            }
        }, 3000);
        return () => clearTimeout(timer);
    }, [mintInfo.status]);

    const reloadInfo = () => {
        window.location.reload();
    }

    return (
        <>
            <Header />
            <div className="Revving">
                <h2 className="Revving__h2">
                    <picture>
                        <source type="image/webp" srcSet={RevvingH2Webp} />
                        <img src={RevvingH2} alt="Revving" />
                    </picture>
                </h2>

                {/* connectしてれば */}
                {info.connected ? (
                    <>
                        {/* NFT保有してれば */}
                        {Array.isArray(mintInfo.owner_of) && mintInfo.owner_of.length > 0 ? (
                            <>
                                <p className="Revving__description">Revving increase RPM. <br />Accumulating RPM unlocks rewards.</p>
                                <Spacer size={24} />
                                <Caution />
                                <div className="Revving__itemContainer">
                                    {Array.isArray(mintInfo.revving_period) && mintInfo.revving_period.map((item, index) => {
                                        return (
                                            <div className={item.revving ? 'Revving__item revving' : 'Revving__item'} key={index}>
                                                <div className="Revving__item__icon">
                                                    <img src={metadata[mintInfo.owner_of[index]].image_url} alt="image" />
                                                </div>
                                                <div className="Revving__item__rightContainer">
                                                    <div>
                                                        <h2 className="Revving__item__no">No. {mintInfo.owner_of[index]}</h2>
                                                        {item.revving ? (
                                                            <div className="Revving__item__status">
                                                                <p>Status</p>
                                                                <p>Revving Now</p>
                                                            </div>
                                                        ) : (
                                                            <div className="Revving__item__status">
                                                                <p>Status</p>
                                                                <p>Not Revving</p>
                                                            </div>
                                                        )}

                                                        <div className="Revving__item__rpm">
                                                            <div className="Revving__item__rpmIcon">
                                                                {item.revving ? (
                                                                    <picture>
                                                                        <source type="image/webp" srcSet={RevvingColorWebp} />
                                                                        <img src={RevvingColor} alt="RPM icon" />
                                                                    </picture>
                                                                ) : (
                                                                    <picture>
                                                                        <source type="image/webp" srcSet={RevvingMonoWebp} />
                                                                        <img src={RevvingMono} alt="RPM icon" />
                                                                    </picture>
                                                                )}
                                                            </div>
                                                            <p className="Revving__item__rpmText">
                                                                {metadata[mintInfo.owner_of[index]].tribe === "Human" ? (
                                                                    <span className="Revving__item__total">{Math.floor(item.total / 600)}</span>
                                                                ) : null}
                                                                {metadata[mintInfo.owner_of[index]].tribe === "Mecha" ? (
                                                                    <span className="Revving__item__total">{Math.floor(item.total / 570)}</span>
                                                                ) : null}
                                                                {metadata[mintInfo.owner_of[index]].tribe === "Chimera" ? (
                                                                    <span className="Revving__item__total">{Math.floor(item.total / 540)}</span>
                                                                ) : null}
                                                                rpm</p>
                                                        </div>
                                                    </div>

                                                    <div className="Revving_item_revvingBtnContainer">
                                                        {item.revving ? (
                                                            <button className="Revving__item__revvingBtn Revving__item__revvingBtn--stop" onClick={() => toggleRevvingFunc(mintInfo.owner_of[index])}>Stop Revving</button>
                                                        ) : <button className="Revving__item__revvingBtn" onClick={() => toggleRevvingFunc(mintInfo.owner_of[index])}>Revving</button>}

                                                        {metadata[mintInfo.owner_of[index]].tribe === "Human" ? (

                                                            Math.floor(item.total / 600) < 100000 ? (
                                                                null
                                                            ) : <DownloadButton
                                                                downloadUrl={metadata[mintInfo.owner_of[index]].download_url}
                                                                index={index}
                                                                metadata={metadata}
                                                                mintInfo={mintInfo}
                                                            />

                                                        ) : null}
                                                        {metadata[mintInfo.owner_of[index]].tribe === "Mecha" ? (
                                                            Math.floor(item.total / 570) < 100000 ? (
                                                                null
                                                            ) : <DownloadButton
                                                                downloadUrl={metadata[mintInfo.owner_of[index]].download_url}
                                                                index={index}
                                                                metadata={metadata}
                                                                mintInfo={mintInfo}
                                                            />
                                                        ) : null}
                                                        {metadata[mintInfo.owner_of[index]].tribe === "Chimera" ? (
                                                            Math.floor(item.total / 540) < 100000 ? (
                                                                null
                                                            ) : <DownloadButton
                                                                downloadUrl={metadata[mintInfo.owner_of[index]].download_url}
                                                                index={index}
                                                                metadata={metadata}
                                                                mintInfo={mintInfo}
                                                            />
                                                        ) : null}



                                                    </div>
                                                </div>

                                            </div>
                                        );
                                    })}

                                </div>
                            </>
                        ) : (
                            // <div className="Revving__detectedContainer">
                            //     {/* 所有してなければ */}
                            //     <p>No BŌSŌ NFTs detected.</p>
                            //     <p>{info.account}</p>
                            // </div>
                            null
                        )}
                    </>
                ) : null}

                {info.connected ? (
                    <div className="Revving__detectedContainer">
                        {/* NFTを取得中のstatusを表示 */}
                        <p>{mintInfo.nft_own_status}</p>
                    </div>
                ) : null}

                {/* connectしてなければ */}
                {!info.connected ? (
                    <>
                        <p className="Revving__detectedContainer">Rev your soul. Rev your engine. Rev your BŌSŌ NFTs.
                            Staking your BŌSŌ NFTs will passively earn you rewards.<br />
                            Revving more, earns you more.<br />
                            Do you hear the sound of a REVolution?
                        </p>
                    </>
                ) : null}

                {/* Revvingトグルを押したときに表示するstatus */}
                {/* <p>{mintInfo.status}</p> */}
                {mintInfo.isStatus ? (
                    <div className={mintInfo.status === "Failed" ? "Sale__bannerMessage error" : "Sale__bannerMessage success"}>
                        <div className="Sale__bannerMessage__textContainer">
                            {mintInfo.status === "Failed" ? (
                                <img className="Sale__bannerMessage__icon" src={errorIcon} alt="error icon" />
                            ) : (
                                <img className="Sale__bannerMessage__icon" src={timeIcon} alt="time icon" />
                            )}
                            <div>
                                <p className="Sale__bannerMessage__text">{mintInfo.status}</p>
                            </div>
                        </div>
                    </div>
                ) : null}

                {/* ネットワークが違うと全画面に注意テキストを表示する */}
                {info.network !== null && !info.network ? (
                    <div className="Sale__bannerMessage error">
                        <div className="Sale__bannerMessage__textContainer">
                            <img className="Sale__bannerMessage__icon" src={errorIcon} alt="check icon" />
                            <div>
                                <p className="Sale__bannerMessage__text">You're currently connected to a different network.</p>
                                <p className="Sale__bannerMessage__text">Please change your network to Ethereum Chain. </p>
                            </div>
                        </div>
                    </div>
                ) : null}

                {/* ConnectButtonContainer */}
                <div className="ConnectButtonContainer">
                    {/* Disconnect Wallet */}
                    {window.ethereum ? (
                        <>
                            {info.connected ? (
                                <>
                                    <p className="Sale__note--white">To disconnect your Metamask, do so from your Metamask.</p>
                                    <span className="ConnectWallet__button--disconnect">
                                        {/* アカウント表示 */}
                                        {String(info.account).substring(0, 6) +
                                            "..." +
                                            String(info.account).substring(38)}
                                    </span>
                                </>
                            ) : (
                                <button
                                    className="ConnectWallet__button--Revving"
                                    onClick={handleConnect}
                                >
                                    <>
                                        <b>Rev it up</b><br />
                                        Connect Wallet
                                    </>
                                </button>
                            )}
                        </>
                    ) : (
                        <button
                            className={info.connected ? "ConnectWallet__button--disconnect" : "ConnectWallet__button"}
                            onClick={handleConnect}
                        >
                            {info.account ? "Disconnect Wallet" : "Connect Wallet"}
                            {/* アカウント表示 */}
                            {info.connected ? (
                                <span>
                                    : {String(info.account).substring(0, 6) +
                                        "..." +
                                        String(info.account).substring(38)}
                                </span>
                            ) : null}
                        </button>
                    )}


                    {/* ウォレットに接続してなければ */}
                    {!info.connected ? (
                        <p className="Sale__note--white">Your wallet is not connected. Connect to proceed.</p>
                    ) : null}

                    {/* リロードボタン */}
                    {info.connected ? (
                        <button onClick={() => reloadInfo()} className="ConnectWallet__button--disconnect">Reload</button>
                    ) : null}
                </div>

                {/* Please install metamask.などの注意 */}
                {info.status ? (
                    <p className="Sale__note--red">
                        {info.status}
                    </p>
                ) : null}

                {/* 接続情報 */}
                {/* {info.connected ? (
                    <details className="Debug">
                        <summary className="Debug__summary">開発用の情報</summary>
                        <ul>
                            {info.connected ? (
                                <li>connected</li>
                            ) : <li>not connected</li>}

                            {info.wallet_connect ? (
                                <li>WalletConnectで接続してます</li>
                            ) : <li>MetaMaskで接続してます</li>}

                            {mintInfo.revving_period.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <li>No. {mintInfo.owner_of[index]}</li>
                                        <li>revving_period.total: {item.total}</li>
                                        {metadata[mintInfo.owner_of[index]].tribe === "Human" ? (
                                            <li>人型: {Math.floor(item.total / 600)}RPM</li>
                                        ) : null}
                                        {metadata[mintInfo.owner_of[index]].tribe === "Mecha" ? (
                                            <li>メカ型: {Math.floor(item.total / 540)}RPM</li>
                                        ) : null}
                                        {metadata[mintInfo.owner_of[index]].tribe === "Chimera" ? (
                                            <li>キメラ型: {Math.floor(item.total / 480)}RPM</li>
                                        ) : null}
                                        {item.revving ? (
                                            <li>revving中</li>
                                        ) : <li>revving中ではない</li>}
                                        <li>image url: {metadata[mintInfo.owner_of[index]].image_url}</li>
                                        <li>tribe: {metadata[mintInfo.owner_of[index]].tribe}</li>
                                    </div>
                                );
                            })}
                            <li>所有NFT: {mintInfo.owner_of}</li>
                            <li>所有数: {mintInfo.owner_of.length}</li>
                            <li>total sold: {mintInfo.sold}</li>
                        </ul>
                    </details>
                ) : null} */}

            </div>
            {/* <Gallery /> */}
            <Footer />
        </>
    );
}

export default Revving;